<script setup>
import IconBase from '../icon/IconBase.vue';
import IconPlay from '../icon/IconPlay.vue';
import IconPlus from '../icon/IconPlus.vue';
import IconBookOpen from '../icon/IconBookOpen.vue';
import IconMediaflowEmptyPlaceholderImage from '../icon/IconMediaflowEmptyPlaceholderImage.vue';
import FormButton from '../Atoms/FormButton.vue'
import EmptyState from '../ui/EmptyState.vue'

const emit = defineEmits({
  'createMediaflow': () => true
})
const showCreateMediaflowModal = () => emit('createMediaflow')
const showDemo = () => emit('showDemo')
</script>

<template>
  <main>
    <EmptyState>
      <template #illustration>
        <icon-base :width="128" :height="120" :width-view-box="128" :height-view-box="120">
          <icon-mediaflow-empty-placeholder-image />
        </icon-base>
      </template>
      <template #subtitle>
        Build scenes from live streams, videos, images, and URLs, then switch between them and go live in one click
      </template>
      <template #actions>
        <FormButton type="secondary" class=" w-64 justify-center" href="https://docs.castr.com/en/articles/12310739-cloud-production-live-switching-made-simple">
          <icon-base class="mr-2">
            <icon-book-open />
          </icon-base>
          How Cloud Production works
        </FormButton>
        <FormButton type="secondary" class=" w-64 justify-center" @click="showDemo">
          <icon-base class="mr-2">
            <icon-play />
          </icon-base>
          Watch a tutorial
        </FormButton>
        <FormButton class=" w-64 justify-center" @click="showCreateMediaflowModal">
          <icon-base class="mr-2">
            <icon-plus />
          </icon-base>
          New Cloud Production
        </FormButton>
      </template>
    </EmptyState>
  </main>
</template> 